import { OfferData } from '../../core/domain/offerData.model'
import { OfferDocumentDTO } from '../../core/domain/offerDocument.dto'
import OfferService from '../../core/services/offer.service'
import { getOfferDocumentId } from '../../core/services/storage.service'
import { LifecyclePresenter } from '../_components/ConnectComponent'
import { AdobeEventManager } from '../_utils/adobeAnalytics'
import { goToHelvetiaLandingPage } from '../_utils/links'
import { SaveAndRetreiveRaw, View } from './SaveAndRetreive.view'

export class SaveAndRetreivePresenter implements LifecyclePresenter<View> {
  private view!: SaveAndRetreiveRaw
  protected document: OfferDocumentDTO
  protected offer: OfferData

  initialize(view) {
    this.view = view
  }

  onLifecycleStart = async () => {
    await this.getOfferDocument()
    AdobeEventManager.emit('Save&Retrieve_init', 'request')
    this.view.setInitialValues(this.document.pricingDate)
  }

  getOfferDocument = async () => {
    try {
      this.document = await OfferService.getOfferDocument(getOfferDocumentId())
      this.offer = this.document.offerData
    } catch (error) {
      console.log(error)
    }
  }

  onSave = () =>
    OfferService.saveOfferData(this.offer).then(() => {
      this.onShowViewModal()
    })

  onShowViewModal = () => this.view.showModal()

  onHideModalHandler = () => {
    this.view.showLoading()
    goToHelvetiaLandingPage()
  }

  onBack = () =>
    OfferService.saveOfferData(this.offer).then(() => {
      this.view.props.history.push('/summary')
    })
}
